<template>
  <div class="h-full">
   <div class=" h-full min-h-screen lg:overflow-hidden xl:overflow-hidden md:overflow-hidden flex flex-col container-custom mx-auto">

      <MozHeader class="mt-6 lg:my-6 xl:my-6">
        <StubCity class="ml-5 mr-2 text-base hidden lg:inline-block" :theme="'main-text'" />
      </MozHeader>
      <slot />
      <div class="w-40 mt-8">
      </div>
    </div>
    <MozFooter class="mt-auto" />
  </div>
</template>

<script>
import MozFooter from '@/views/home-page-layouts/home-footer';
import MozHeader from '@/helpers/moz-header.vue';
import StubCity from '@/views/stub/stub_city.vue';
import * as Cookies from 'js-cookie';
import players from '@/clients/player';
import VueMeta from 'vue-meta';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    MozFooter,
    StubCity,
    MozHeader,
    VueMeta,
  },
  metaInfo: {
    meta: [
      {
        name: 'robots',
        content: 'noindex',
      },
    ],
  },
  created() {
    const fromCookie = Cookies.get('mozgoAuth');

    if (fromCookie && fromCookie.length) this.refreshUser(players);

    if (this.user.role !== 'player' && (!fromCookie && !fromCookie.length)) {
      this.$router.push('/');
    }
    if (this.defaultIsShowed === false) {
      this.selectModalCookieText('Мы используем cookies для быстрой и удобной работы сайта. ' +
          'Продолжая пользоваться сайтом, вы принимаете условия обработки персональных данных.'); this.selectShowCookieModal(true);
    }
  },
  methods: {
    ...mapActions(['selectShowCookieModal', 'selectModalCookieText', 'refreshUser']),
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      defaultIsShowed: state => state.cookieNotic.isShowed,
    }),
    route() {
      return !!this.$route.params.memberId;
    },
  },

};
</script>
<style scoped>
.container-custom {
  max-width: 80%;
}
@media (max-width: 840px){
  .container-custom {
    max-width: 90%;
  }
}
</style>
